import { combineReducers } from 'redux';
import UserReducer from './User/reducer';
import EventDataReducer from './EventData/reducer';
import ProductsReducer from './Products/reducer';
import BillingInfoReducer from './BillingInfo/reducer';
import EmailReducer from './Email/reducer';
import GaugesReducer from './Gauges/reducer';
import UserSettingsReducer from './UserSettings/reducer';
import UserLaneReducer from './UserLane/reducer';
import BrandingReducer from './Branding/reducer';

const rootReducer = combineReducers({
    user: UserReducer,
    evtData: EventDataReducer,
    products: ProductsReducer,
    billingInfo: BillingInfoReducer,
    email: EmailReducer,
    gauges: GaugesReducer,
    userSettings: UserSettingsReducer,
    userLane: UserLaneReducer,
    branding: BrandingReducer,
});

export default rootReducer;

export type AppState = ReturnType<typeof rootReducer>;
